import styled, {css} from "styled-components"
import {H1} from "@irati/ui/src/Typography"

import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"

export const NextButton = styled(Button).attrs({primary: true, full: true})`
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 25%;
    `}
    ${theme.mediaQueries.maxWidthMedia.phone`
      margin-bottom: ${theme.spacing.one};
    `}
  `}
`

export const Image = styled.img`
  ${({theme}) => css`
    height: 200px;
    ${theme.mediaQueries.minWidthMedia.tablet`
      height: 240px;
    `}
  `}
`

export const Footer = styled(Flex)`
  ${({theme}) => css`
    flex-direction: column;
    ${theme.mediaQueries.minWidthMedia.tablet`
      flex-direction: row;
      justify-content: space-between;
    `}
  `}
`

export const Wrapper = styled(Flex)`
  flex-direction: column;
  ${({theme}) => `
    ${theme.mediaQueries.minWidthMedia.phone`
      margin: 0 0 ${theme.spacing.two};
    `}
`}
`

export const Title = styled(H1)`
  ${({theme}) => css`
    color: ${theme.colors.utility.ink};
    margin-bottom: ${theme.spacing.one};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-bottom: ${theme.spacing.two};
    `};
  `}
`

export const FooterActions = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.tablet`
      display: flex; 
      flex-direction: row; 
      justify-content: space-between;
    `};
    ${theme.mediaQueries.maxWidthMedia.phoneLandscape`
      width: 100%;
    `}
  `}
`

export const ButtonWrapper = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.phoneLandscape`
      width: 100%;
      margin-bottom: 5px;
    `}
  `}
`
